import { render, staticRenderFns } from "./ComplianceRatioBranch.vue?vue&type=template&id=536fa99a"
import script from "./ComplianceRatioBranch.vue?vue&type=script&lang=js"
export * from "./ComplianceRatioBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports